type Record = {
  uuid: string;
};

export function findMatchingRecord<T extends Record>(
  records: (T | null)[] | undefined,
  uuid: string
): T | null | undefined {
  if (records) {
    return records.find((r: T | null) => !!r && r.uuid === uuid);
  }
}

export function findMatchingRecordIndex<T extends Record>(
  records: (T | null)[],
  uuid: string
): number | undefined {
  if (records) {
    return records.findIndex((r: T | null) => !!r && r.uuid === uuid);
  }
}
